module.exports = __webpack_public_path__ + "img/elektrophile-addition.beaddd19.png";